import { inject } from '@angular/core';
import { CanActivateChildFn, CanActivateFn, Router } from '@angular/router';
import { of, switchMap } from 'rxjs';
import {UserService} from "../../user/service/user.service";

export const AdminGuard: CanActivateFn | CanActivateChildFn = (route, state) => {
    const router: Router = inject(Router);

    // Check the authentication status
    return inject(UserService)
        .isAdmin$()
        .pipe(
            switchMap((isAdmin) => {
                if (!isAdmin) {
                    const urlTree = router.parseUrl(``);

                    return of(urlTree);
                }

                return of(true);
            })
        );
};
